import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import jwtDecode from "jwt-decode";
import googleActions from "modules/google/actions";
import styled from "styled-components";
import googleSelectors from "modules/google/selectors";
import { useTranslation } from "react-i18next";

const SigninButton = ({ mode, linkTitle }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { REACT_APP_GOOGLE_ADS_API_CLIENT_ID } = process.env;
  const readyplanetEmailPattern = /^[A-Za-z0-9._%+-]+@readyplanet.com$/gi;
  let accessToken;
  let userInfo;
  let client;

  const handleCredentialResponse = async (response) => {
    userInfo = jwtDecode(response.credential);

    await initClientToken();

    if (accessToken && accessToken !== "") {
      userInfo.access_token = accessToken;
    }

    if (readyplanetEmailPattern.test(userInfo.email)) {
      userInfo.isManual = true;
    } else {
      userInfo.isManual = false;
    }

    // Set userObject to redux
    dispatch(googleActions.setGoogleUserInfo(userInfo));
    dispatch(googleActions.changeSettingPage("ads_setup"));
  };

  useEffect(() => {
    if (mode !== "link") {
      const lang = sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en";

      google.accounts.id.initialize({
        client_id: REACT_APP_GOOGLE_ADS_API_CLIENT_ID,
        callback: handleCredentialResponse,
      });
      google.accounts.id.renderButton(
        document.getElementById("google_signin_button"),
        { theme: "filled_blue", size: "large", width: 250, locale: lang }, // customization attributes
      );
      // google.accounts.id.prompt() // also display the One Tap dialog
    }
  }, [mode]);

  const Auth = async () => {
    try {
      await initClientToken();
      const getUserInfoResult = await dispatch(
        googleActions.getGoogleUserInfo({
          token: accessToken,
        }),
      );

      userInfo = getUserInfoResult;

      if (accessToken && accessToken !== "") {
        userInfo.access_token = accessToken;
      }

      if (readyplanetEmailPattern.test(userInfo.email)) {
        userInfo.isManual = true;
      } else {
        userInfo.isManual = false;
      }

      // Set userObject to redux
      dispatch(googleActions.setGoogleUserInfo(userInfo));
      dispatch(googleActions.changeSettingPage("ads_setup"));
    } catch (error) {
      console.log("Auth Error: ", error.message);
    }
  };

  const initClientToken = () => {
    return new Promise((resolve, reject) => {
      try {
        client = google.accounts.oauth2.initTokenClient({
          client_id: REACT_APP_GOOGLE_ADS_API_CLIENT_ID,
          scope: "email https://www.googleapis.com/auth/adwords",
          prompt: "",
          callback: (response) => {
            if (response.access_token !== undefined) {
              accessToken = response.access_token;
              resolve(true);
            } else {
              throw new Error("AUTH_FAILED");
            }
          },
        });

        client.requestAccessToken();
      } catch (error) {
        reject(error);
      }
    });
  };

  if (mode !== "link") {
    return (
      <div>
        <SigninButtonContainer>
          <AuthDummyButton onClick={Auth}></AuthDummyButton>
          <div id="google_signin_button"></div>
        </SigninButtonContainer>
      </div>
    );
  } else {
    return <Link onClick={Auth}>{linkTitle}</Link>;
  }
};

const AuthDummyButton = styled.div`
  z-index: 1;
  position: absolute;
  width: 250px;
  height: 44px;
  cursor: pointer;
`;

const SigninButtonContainer = styled.div`
  position: relative;

  @media screen and (max-width: 834px) {
    display: flex;
    justify-content: center;
  }
`;

const Link = styled.span`
  cursor: pointer;
  color: #337ab7;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default SigninButton;
